import type { FanTopic } from "@/types";

export const fanTopics: FanTopic[] = [
  {
    id: "fans-01",
    title: "关于《雾港》结局的三种解读，你更认同哪一种？",
    preview:
      "有人说那是释怀，有人说是另一种遗憾，也有人觉得真相其实一直藏在雾里。整理了三种主流解读，欢迎补充你的看法。",
    content: [
      "《雾港》上映后，结局成为大家讨论最多的话题。有人认为是释怀，有人认为是延迟的遗憾，也有人坚持真相始终没有被说出口。",
      "第一种解读聚焦“雾”的象征，认为主人公最终选择与真相和解；第二种解读强调镜头语言中的留白，认为是刻意的不交代；第三种解读则从时间线出发，认为结局是一个循环。",
      "你更倾向哪一种？欢迎在下方留下你的推理线索。",
    ],
    replies: 328,
    tag: "作品讨论",
    date: "2026-10-10",
    author: "雾港观察员",
  },
  {
    id: "fans-02",
    title: "把你最喜欢的一句台词留在这里",
    preview: "从《山与海之间》到《雾港》，总有那么一句台词，在某个瞬间击中过你。",
    content: [
      "每一部作品里，总有一两句台词会在之后的日子里反复出现。",
      "也许是关于告别，也许是关于原谅，也许只是一句再普通不过的日常对白。",
      "把它们写下来吧，让更多人看到那些被记住的瞬间。",
    ],
    replies: 512,
    tag: "情感共鸣",
    date: "2026-10-07",
    author: "拾光收藏者",
  },
  {
    id: "fans-03",
    title: "云观影招募：一起重温《山与海之间》",
    preview: "本周六晚，一起在线上同步观看《山与海之间》，映后开放 30 分钟自由交流。",
    content: [
      "本周六晚我们会在线上同步观看《山与海之间》，欢迎新老粉丝一起参与。",
      "影片结束后设有 30 分钟自由交流环节，主题是“你生命中的那座山与那片海”。",
      "参与方式为线上报名，具体链接会在活动前一天公布。",
    ],
    replies: 176,
    tag: "活动招募",
    date: "2026-10-03",
    author: "官方活动小组",
  },
  {
    id: "fans-04",
    title: "生日应援创意征集：我们想送你一片星海",
    preview: "今年生日应援希望更有参与感，征集所有关于“光”的创意，欢迎投稿。",
    content: [
      "今年我们想做一个更有参与感的生日应援，主题是“光”。",
      "你可以提交照片、绘画、短文或短视频，只要能表达你心中那束光。",
      "入选作品会一起出现在官方应援影像中，让更多人看到。",
    ],
    replies: 421,
    tag: "应援",
    date: "2026-09-29",
    author: "应援策划组",
  },
  {
    id: "fans-05",
    title: "《潮汐备忘录》听后感交流帖",
    preview: "第一次听《潮汐备忘录》时你在做什么？五首作品里，哪一首最贴近你现在的心情？",
    content: [
      "《潮汐备忘录》发行已经有一段时间了，很多朋友说每首歌对应一种心情。",
      "有人喜欢开篇的克制，有人偏爱最后一首的释然。",
      "分享一下你的听后感吧，也许会发现有人和你听着同一段旋律。",
    ],
    replies: 289,
    tag: "音乐",
    date: "2026-09-24",
    author: "潮汐听众",
  },
  {
    id: "fans-06",
    title: "第一次认识风间由美，是从哪一部作品开始？",
    preview: "很多人说，认识一个人只需要一个瞬间。你的那个瞬间，是哪一部作品？",
    content: [
      "从早期的《回声的另一半》到后来的《雾港》，每个人的起点都不一样。",
      "有人因为某个角色，有人因为一首歌，也有人只是因为一次采访里的真诚。",
      "写下你的“第一部”吧，说不定能遇到和你同一天入坑的人。",
    ],
    replies: 634,
    tag: "相识故事",
    date: "2026-09-18",
    author: "新粉报到站",
  },
];